import {formatDate, isToday, toLocalDateString} from "@/utils/DateUtils";

/** Period of the report: `from` up to and including `to` (local days). */
export type ReportPeriod = {
    from: Date,
    to: Date,
};

/** Whether the period is one day. */
export const isSingleDay = (period: ReportPeriod): boolean =>
    toLocalDateString(period.from) === toLocalDateString(period.to);

/** Whether the period is only today: the default, without URL parameters. */
export const isOnlyToday = (period: ReportPeriod): boolean =>
    isSingleDay(period) && isToday(period.from);

/**
 * The period as text, e.g. `04-11-26` or `01-11-26 - 30-11-26`. Also used in
 * the CSV export and its file name, so without slashes.
 */
export const formatPeriod = (period: ReportPeriod): string =>
    isSingleDay(period)
        ? formatDate(period.from)
        : `${formatDate(period.from)} - ${formatDate(period.to)}`;